import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PosService } from "src/app/core/services/pos.service";
import { CheckDto } from "src/app/shared/models/check-dto";

@Component({
	selector: "app-pos-check-list",
	templateUrl: "./pos-check-list.component.html",
	styleUrls: ["./../../pos.scss"],
})
export class PosCheckListComponent implements OnInit {
	@Input() checkSelected: CheckDto;
	@Output() checkSelectedChange = new EventEmitter<CheckDto>();

	@Input() viewCheckList: boolean;
	@Output() viewCheckListChange = new EventEmitter<boolean>();
	constructor(public posService: PosService) {}

	ngOnInit(): void {}

	onSelectCheck(check: CheckDto) {
		this.posService.orderService.activeOrder.next(check);
		this.viewCheckListChange.emit(false);
	}
}
